import { ComponentProps } from "react";

import styles from "./drawer-body.module.css";

export type DrawerBodyProps = ComponentProps<"div">;

export const DrawerBody = ({
  children,
  className = "",
  ...props
}: DrawerBodyProps) => {
  return (
    <div className={`${styles.Container} ${className}`} {...props}>
      {children}
    </div>
  );
};
